import PackageAttributesTile   from './PackageAttributesTile'

export * from './PackageAttributesTile'

export default PackageAttributesTile